import { ModalBody, ModalHeroImage } from '@strava/ui/Modal';
import React from 'react';
import { useOnboardingContext } from '../../../../state/OnboardingContext';
import welcomeImage from './images/welcome.jpg';

const Welcome = () => {
  const { state } = useOnboardingContext();

  return (
    <>
      <ModalHeroImage src={welcomeImage} alt="welcome" />
      <ModalBody>
        <h2>Welcome, {state.currentAthlete.id}!</h2>
        <p>
          Start uploading activities, compete with friends, build your community
          and most importantly, have fun!
        </p>
      </ModalBody>
    </>
  );
};

export default Welcome;
